import { render, staticRenderFns } from "./VideoSales.vue?vue&type=template&id=35a0a239&"
import script from "./VideoSales.vue?vue&type=script&lang=js&"
export * from "./VideoSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports